import { render, staticRenderFns } from "./ShowMoreLess.vue?vue&type=template&id=cf82f140&scoped=true&"
import script from "./ShowMoreLess.vue?vue&type=script&lang=js&"
export * from "./ShowMoreLess.vue?vue&type=script&lang=js&"
import style0 from "./ShowMoreLess.vue?vue&type=style&index=0&id=cf82f140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf82f140",
  null
  
)

export default component.exports